import OutOfOfficeOptionsItem     from "./Collections/OutOfOfficeOptionsItem.js";
import OutOfOfficeHTTPService     from "./HTTP/OutOfOfficeHTTPService.js";
import OutOfOfficeHTTPMapping     from "./HTTP/OutOfOfficeHTTPMapping.js"
import HTTPResponseEntity         from "@/js/Shared/Services/HTTP/Entities/HTTPResponseEntity.js";
import NotificationsController    from "@/js/Webmail/Notifications/NotificationsController";
import LanguageController         from "@/js/Shared/Language/Language";

export { OutOfOfficeOptionsController as default };

/**
* Out of Office Options Controller
*
* @author      fheitor <fabio-h-nascimento@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/

class OutOfOfficeOptionsController {
  /**
   * Out of Office Options
   *
   * @public
   *
   * @type {OutOfOfficeOptionsItem}
   *
   * @since 7.0.0
   */
   options = new OutOfOfficeOptionsItem();

  /**
   * HTTP Mapping object
   *
   * @private
   *
   * @type {OutOfOfficeHTTPMapping}
   *
   * @since 7.0.0
   */
  http_mapping = new OutOfOfficeHTTPMapping();

  /**
   * HTTP Service object
   *
   * @private
   *
   * @type {MessagesOptionsHTTPService}
   *
   * @since 7.0.0
   */
  http_service = new OutOfOfficeHTTPService();

  /**
   * Defines current predifined message
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  predefined_message;

  /**
   * Defines last predifined message
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  last_predefined_message;

  /**
 * Fetchs Out of Office options from APi Service
 *
 * @public
 *
 * @since 7.0.0
 *
 * @return {Promise.<boolean>}
 */
  async fetchOptions() {
    let response =  await this.http_service.fetchOptions();

    if (response.success === false) {
      NotificationsController.addMessage('notifications.', response.messages);
      return false;
    }

    this.http_mapping.map(this.options, response);
    return response.success;
  }

 /**
 * Calls the HTTP Service to save the out of office options
 *
 * @public
 *
 * @since 7.0.0
 *
 * @return {Promise.<boolean>}
 */
  async saveOptions() {
    let response = await this.http_service.saveOptions(this.options);
    NotificationsController.addMessage('notifications.', response.messages);
    this.http_mapping.map(this.options, response);
    return response.success;
  }

  /**
   * Sets the predifined message according to the current set date values
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  setPredefinedTagByDate = () => {
    let replacements = [this.options.date_start, this.options.date_end];

    if(!this.options.date_start && !this.options.date_end) {
      this.setPredifinedMessage('no_dates', replacements);
      return;
    }

    if(this.options.date_start && this.options.date_end) {
      this.setPredifinedMessage('both_dates', replacements);
      return;
    }

    if(!this.options.date_start && this.options.date_end) {
      this.setPredifinedMessage('date_one', replacements);
      return;
    }

    this.setPredifinedMessage('date_two', replacements);
    return;
  }

  /**
   * Sets the predifined message
   *
   * @private
   *
   * @since 7.0.0
   *
   * @param {String} code        language code
   * @param {Array} replacements language replacements
   *
   * @return {void}
   */
  setPredifinedMessage = (code, replacements) => {
    this.last_predefined_message = this.predefined_message;

    this.predefined_message = LanguageController.say(
      'settings.email.out_of_office.predefined_messages.' + code,
      replacements,
    )
  }

  /**
   * Sets out of office options from server response
   *
   * @private
   *
   * @since 7.0.0
   *
   * @param {HTTPResponseEntity} response
   *
   * @return {Promise.<boolean>}
   */
  setOptions(response) {
    if (response.success === false) {
      return;
    }

    this.options = response.results;
  }
}